import { useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  const field = "w-full rounded-xl border border-[#F4EEE2]/15 bg-[#0B111E] px-4 py-3 text-[#F4EEE2] outline-none transition-colors focus:border-[#D4AF37]";
  return (
    <main data-testid="admin-login-page" className="grid min-h-screen place-items-center px-5">
      <form onSubmit={submit} className="w-full max-w-md rounded-[28px] border border-[#D4AF37]/20 bg-[#131C2E] p-8 md:p-10">
        <img src="/images/logo-round.png" alt="Awa In Kelet logo" data-testid="admin-login-logo" className="h-20 w-20 rounded-full ring-1 ring-[#D4AF37]/50" />
        <h1 className="font-display mt-6 text-4xl font-semibold text-[#F4EEE2]">Team Portal</h1>
        <p className="mt-2 text-sm text-[#B7BFCC]">Jikin Team · Sign in to manage messages</p>
        <label className="mt-8 block font-ui text-xs uppercase tracking-widest text-[#B7BFCC]">Email</label>
        <input data-testid="admin-login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={`${field} mt-2`} />
        <label className="mt-5 block font-ui text-xs uppercase tracking-widest text-[#B7BFCC]">Password</label>
        <input data-testid="admin-login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={`${field} mt-2`} />
        <Link to="/admin/forgot-password" data-testid="admin-forgot-password-link" className="mt-3 inline-block font-ui text-xs text-[#D4AF37] underline-offset-4 hover:underline">Forgot password?</Link>
        {error && <p data-testid="admin-login-error" className="mt-4 text-sm text-[#F2A08A]">{error}</p>}
        <button data-testid="admin-login-submit-btn" disabled={busy} className="mt-8 flex w-full items-center justify-center gap-2 rounded-full bg-[#D4AF37] py-3.5 font-ui font-semibold text-[#0B111E] transition-colors hover:bg-[#F3C846] disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
        <Link to="/" className="mt-6 block text-center font-ui text-xs text-[#B7BFCC] hover:text-[#D4AF37]" data-testid="admin-back-home">← Back to site</Link>
      </form>
    </main>
  );
}
